import React from 'react';
import { useTranslation } from 'react-i18next';

import Shimmer from '../../../common/Shimmer';

import checkIcon from '../../../../assets/changeCoverage/check-white.svg';
import accidentOnlyIcon from '../../../../assets/changeCoverage/accident-only.svg';
import accidentIllnessIcon from '../../../../assets/changeCoverage/accident-and-illness.svg';

import styles from '../css/BasePlanCard.module.css';
import { ORCA_CHANGE_COVERAGE_PRODUCT_CODE } from '../../../../constants';

const BasePlanCard = ({
  code = '',
  disabled = false,
  onSelect = () => { },
  price = '',
  selected = false,
  title = '',
}) => {
  const { t } = useTranslation('changeCoverage');

  return (
    <div
      className={styles.planCard}
      data-selected={selected}
    >
      <div className={styles.planCardTitle}>
        <div>
          <h4>{title}</h4>

          <span>{t('options.orca.planLegend')}</span>
        </div>

        <img
          alt=""
          src={code === ORCA_CHANGE_COVERAGE_PRODUCT_CODE
            .accidentOnly ? accidentOnlyIcon : accidentIllnessIcon}
        />
      </div>

      <div className={styles.planCardFooter}>
        <Shimmer
          element="fragment"
          height={27}
          visible={!price}
          width={110}
        >
          <span className={styles.planCardPrice}>
            {price && `${price}${t('options.orca.perMonth')}`}
          </span>
        </Shimmer>

        {selected ? (
          <span className={styles.planCardSelected}>
            <img alt="" src={checkIcon} />

            {t('options.orca.selected')}
          </span>
        ) : (
          <button
            className={styles.planCardSelectButton}
            disabled={disabled}
            onClick={onSelect}
            type="button"
          >
            {t('options.orca.select', { name: title })}
          </button>
        )}
      </div>
    </div>
  );
};

export { BasePlanCard };
